<script>
import {
  pageMonCompteMesAdressesEmits,
  pageMonCompteMesAdressesProps,
  usePageMonCompteMesAdresses
} from "./mixin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";
import Divider from "@/components/atoms/divider";
import Popin from "@/components/molecules/popin";
import ButtonIcon from "@/components/molecules/button-icon";
import MesAdressesSupprimer from "@/components/organisms/mon-compte/mes-adresses-supprimer";
import BillingAdressModifier from "@/containers/adresses-lad/billing-adress-from";
import AddressLadForm from "@/containers/adresses-lad/addresse-lad-form";
import Titre from "@/components/atoms/titre";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import AdresseLadRecap from "@/components/organisms/adresse-lad-recap-livreur";

import illustrationCamionPointInterogation from "@/assets/images/illustration-camion-point-interogation.svg";

export default {
  name: "MesAdressesMobile",
  components: {
    Icon,
    Button,
    LazyImage,
    Card,
    Divider,
    Popin,
    ButtonIcon,
    GridRow,
    GridCol,
    BillingAdressModifier,
    MesAdressesSupprimer,
    AddressLadForm,
    Titre,
    AdresseLadRecap
  },
  props: {
    ...pageMonCompteMesAdressesProps()
  },
  emits: [...pageMonCompteMesAdressesEmits()],
  setup(props, context) {
    const supprimer = ref(null);
    const popinAddressDetail = ref(null);
    const modifierAdresse = ref(null);
    const ajouter = ref(null);
    const {
      adressToDeleteId,
      adressDetailsId,
      addressToEditId,
      error,
      updateBillingAddress,
      deleteAddress,
      showAddressDetails,
      addressDeleted,
      setAddressDefault,
      editAddress,
      addresseLadSaved,
      getAdressDetailsById
    } = usePageMonCompteMesAdresses(
      props,
      context,
      supprimer,
      popinAddressDetail,
      modifierAdresse,
      ajouter
    );

    return {
      adressToDeleteId,
      adressDetailsId,
      addressToEditId,
      error,
      updateBillingAddress,
      deleteAddress,
      showAddressDetails,
      addressDeleted,
      setAddressDefault,
      editAddress,
      addresseLadSaved,
      getAdressDetailsById,
      supprimer,
      popinAddressDetail,
      modifierAdresse,
      ajouter,
      illustrationCamionPointInterogation
    };
  }
};
</script>

<template>
  <div>
    <Popin
      ref="popinAddressDetail"
      aria-label="Indications Livreur"
      slide-up
    >
      <template
        v-if="
          getAdressDetailsById(adressDetailsId) &&
            getAdressDetailsById(adressDetailsId).attributes
        "
      >
        <h2 class="u-font-secondary u-font-700 u-font-19 u-color-primary u-mb-sm">
          Indications Livreur
        </h2>
        <AdresseLadRecap :adresse-lad="getAdressDetailsById(adressDetailsId)" />
      </template>
    </Popin>

    <MesAdressesSupprimer
      ref="supprimer"
      page-back
      @confirm="addressDeleted"
    />
    <BillingAdressModifier
      ref="modifier"
      :client="client"
      page-back
      @updateBillingAddress="updateBillingAddress"
    />
    <Popin
      ref="ajouter"
      aria-label="Adresse de livraison"
      page-back
    >
      <AddressLadForm
        :context="'clientAccountNavigation'"
        @saved="addresseLadSaved()"
      />
    </Popin>
    <Popin
      ref="modifierAdresse"
      aria-label="Modifier une adresse de livraison"
    >
      <h1 class="u-font-24 u-text-center u-color-primary u-mb-lg u-mb-none@sm u-p-sm@sm">
        Modifier une adresse de livraison
      </h1>
      <AddressLadForm
        :addresse-id="addressToEditId"
        @cancel="$refs.modifierAdresse.hide()"
        @saved="addresseLadSaved()"
      />
    </Popin>
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-mb-md u-mt-sm u-ml-sm u-mr-sm"
    >
      Mes adresses
    </Titre>

    <template v-if="!isPro">
      <Card
        v-if="adressesLad.length === 0 && !isNational"
        class="u-text-center u-mb-md u-p-sm u-border-y-border"
      >
        <LazyImage
          :src="
            illustrationCamionPointInterogation
          "
          width="80"
          height="58"
          alt=""
          class="u-inline-block"
        />

        <Titre
          tag="h2"
          size="sm"
          class="u-mt-sm u-mb-xs"
        >
          Vous n'avez pas encore défini d'adresse de livraison
        </Titre>
        <p class="u-font-15">
          Vous avez la possibilité d'associer à votre compte client 5 adresses
          de livraison maximum.
        </p>
        <Button
          variant="primary"
          size="md"
          radius="full"
          class="u-mt-md"
          @click="$refs.ajouter.show()"
        >
          J'ajoute une adresse de livraison
        </Button>
      </Card>

      <template v-else-if="adressesLad.length > 0">
        <Card class="u-p-sm u-border-y-border">
          <h2 class="u-font-secondary u-font-700 u-color-primary u-font-19 u-flex u-flex-align-center u-mb-xs">
            <Icon
              name="shipping-lad"
              variant="primary"
              class="u-mr-sm"
            />
            Mes adresses de livraison ({{ adressesLad.length }})
          </h2>
          <template v-if="!isNational">
            <p class="u-font-15 u-mb-xs">
              Vous avez la possibilité d'associer à votre compte client 5
              adresses de livraison maximum.
            </p>
            <Button
              v-if="adressesLad.length < 5"
              variant="primary"
              size="md"
              radius="full"
              class="u-mb-lg"
              @click="$refs.ajouter.show()"
            >
              J'ajoute une adresse de livraison
            </Button>
          </template>
          <h3
            v-if="defaultAddress"
            class="u-font-secondary u-font-700 u-font-17 u-mb-sm"
          >
            Mon adresse habituelle
          </h3>
          <GridRow v-if="defaultAddress && defaultAddress.attributes">
            <GridCol
              cols="4"
              lg="6"
              sm="12"
              class="u-mb-md"
            >
              <div class="u-flex u-flex-align-center">
                <Card
                  class="u-p-sm u-flex-grow"
                  radius="md"
                  border-color="grey-5"
                >
                  <p class="u-mb-xs">
                    <strong class="u-font-500">
                      {{ defaultAddress.attributes.libelle }}
                    </strong>
                  </p>
                  <p>
                    {{ defaultAddress.attributes.civilite }}
                    {{ defaultAddress.attributes.prenom }}
                    {{ defaultAddress.attributes.nom }}
                  </p>
                  <p>
                    {{ defaultAddress.attributes.adresse }}
                  </p>
                  <p>
                    {{ defaultAddress.attributes.complement_adresse }}
                  </p>
                  <p>
                    {{ defaultAddress.attributes.code_postal }}
                    {{ defaultAddress.attributes.nom_commune }}
                  </p>
                  <p
                    v-if="
                      getAdressDetailsById(defaultAddress.id) &&
                        getAdressDetailsById(defaultAddress.id).attributes
                    "
                  >
                    {{ getAdressDetailsById(defaultAddress.id).attributes.tel }}
                  </p>
                  <p
                    v-if="client.attributes.optin_sms_suivi_commande_drive"
                    class="u-mt-xs"
                  >
                    Accepte d'être informé(e) par SMS de l'évolution des
                    commandes
                  </p>
                  <p
                    v-else
                    class="u-mt-xs"
                  >
                    N'accepte pas d'être informé(e) par SMS de l'évolution des
                    commandes
                  </p>
                  <Button
                    link
                    class="u-mt-xs"
                    @click="showAddressDetails(defaultAddress.id)"
                  >
                    Voir les indications pour le livreur
                  </Button>
                </Card>
                <div class="u-ml-sm">
                  <ButtonIcon
                    icon-name="pen"
                    icon-color="text-light"
                    class="u-flex-shrink-none u-mb-sm"
                    @click="editAddress(defaultAddress.id)"
                  />
                  <br />
                  <ButtonIcon
                    icon-name="trash"
                    icon-color="text-light"
                    class="u-flex-shrink-none u-mt-sm"
                    @click="deleteAddress(defaultAddress.id)"
                  />
                </div>
              </div>
            </GridCol>
          </GridRow>

          <h3
            v-if="defaultAddress && otherAddresses.length > 0"
            class="u-font-secondary u-font-700 u-font-17 u-mb-sm"
          >
            Mes autres adresses
          </h3>
          <h3
            v-else-if="otherAddresses.length > 0"
            class="u-font-secondary u-font-700 u-font-17 u-mb-sm"
          >
            Mes adresses
          </h3>
          <GridRow v-if="otherAddresses.length > 0">
            <GridCol
              v-for="adresse in otherAddresses"
              :key="adresse.id"
              cols="4"
              lg="6"
              sm="12"
            >
              <div class="u-flex u-flex-align-center u-mb-sm">
                <Card
                  radius="md"
                  border-color="grey-5"
                  class="u-flex-grow"
                >
                  <div class="u-p-sm">
                    <p class="u-mb-xs">
                      <strong class="u-font-500">
                        {{ adresse.attributes.libelle }}
                      </strong>
                    </p>
                    <p>
                      {{ adresse.attributes.civilite }}
                      {{ adresse.attributes.prenom }}
                      {{ adresse.attributes.nom }}
                    </p>
                    <p>
                      {{ adresse.attributes.adresse }}
                    </p>
                    <p v-if="adresse.attributes.complement_adresse">
                      {{ adresse.attributes.complement_adresse }}
                    </p>
                    <p>
                      {{ adresse.attributes.code_postal }}
                      {{ adresse.attributes.nom_commune }}
                    </p>
                    <p
                      v-if="
                        getAdressDetailsById(adresse.id) &&
                          getAdressDetailsById(adresse.id).attributes
                      "
                    >
                      {{ getAdressDetailsById(adresse.id).attributes.tel }}
                    </p>
                    <p
                      v-if="client.attributes.optin_sms_suivi_commande_drive"
                      class="u-mt-xs"
                    >
                      Accepte d'être informé(e) par SMS de l'évolution des
                      commandes
                    </p>
                    <p
                      v-else
                      class="u-mt-xs"
                    >
                      N'accepte pas d'être informé(e) par SMS de l'évolution des
                      commandes
                    </p>
                    <Button
                      link
                      class="u-mt-xs"
                      @click="showAddressDetails(adresse.id)"
                    >
                      Voir les indications pour le livreur
                    </Button>
                  </div>
                  <Divider class="u-m-none" />
                  <div class="u-p-sm">
                    <Button
                      link
                      variant="primary"
                      @click="setAddressDefault(adresse.id)"
                    >
                      Définir comme adresse habituelle
                    </Button>
                  </div>
                </Card>
                <div class="u-ml-sm">
                  <ButtonIcon
                    icon-name="pen"
                    icon-color="text-light"
                    class="u-flex-shrink-none u-mb-sm"
                    @click="editAddress(adresse.id)"
                  />
                  <br />
                  <ButtonIcon
                    icon-name="trash"
                    icon-color="text-light"
                    class="u-flex-shrink-none u-mt-sm"
                    @click="deleteAddress(adresse.id)"
                  />
                </div>
              </div>
            </GridCol>
          </GridRow>
        </Card>
      </template>
    </template>

    <Card class="u-p-sm u-mt-md u-mb-lg u-border-y-border">
      <h2 class="u-font-secondary u-color-primary u-font-700 u-font-17 u-mb-sm u-flex u-flex-align-center u-mb-xs">
        <Icon
          name="command"
          variant="primary"
          class="u-mr-sm"
        />
        Mon adresse de facturation
      </h2>

      <GridRow>
        <GridCol
          cols="4"
          lg="6"
          sm="12"
          class="u-mb-md"
        >
          <div class="u-flex u-flex-align-center">
            <Card
              class="u-p-md u-flex-grow"
              radius="md"
              border-color="grey-5"
            >
              <p class="u-mb-xs">
                Adresse : {{ client.attributes.adresse }}
              </p>
              <p class="u-mb-xs">
                Complément : {{ client.attributes.complement_adresse }}
              </p>
              <p class="u-mb-xs">
                Code postal : {{ client.attributes.cp }}
              </p>
              <p class="u-mb-xs">
                Ville : {{ client.attributes.ville }}
              </p>
              <p class="u-mb-xs">
                Pays : {{ client.attributes.pays }}
              </p>
              <p>Etat/Département : {{ client.attributes.departement }}</p>
            </Card>
            <div
              v-if="!isPro"
              class="u-ml-sm"
            >
              <ButtonIcon
                icon-name="pen"
                icon-color="text-light"
                class="u-flex-shrink-none"
                @click="$refs.modifier.show()"
              />
            </div>
          </div>
        </GridCol>
      </GridRow>
    </Card>
  </div>
</template>

<style lang="scss" scoped></style>
